import { BASIC_AUTH, Configuration } from "../utils/configuration";
import { APIOptions } from "./hooks/useApiBase";
import { useApiLazy, UseAPILazyProps } from "./hooks/useApiLazy";
import {
  MunicipalityChangeRequest,
  NewMunicipalityRequest,
  UpdateMunicipalityStatus,
} from "./types/municipalities.types";

/**
 * Config
 */
const hostOverride = Configuration.gatewayUrl;

/**
 * Hooks
 */
// 🟦 GET /review/rating/v1/municipalities/status/pending - Get all municipalities
export function useApiGetMunicipalitiesPending(
  options: APIOptions<undefined | MunicipalityChangeRequest[]> = {}
) {
  const props: UseAPILazyProps<undefined | MunicipalityChangeRequest[]> = {
    url: "review/rating/v1/municipalities/status/pending",
    kind: "get",
    options,
    header: {
      Authorization: `Basic ${BASIC_AUTH}`,
    },
    hostOverride,
  };
  const api = useApiLazy<undefined | MunicipalityChangeRequest[]>(props);
  const call = async () => await api.call(props);
  return { ...api, call };
}

// 🟩 POST /review/rating/v1/municipalities/batch - Create a new municipality request batch
export function useApiCreateMunicipalityRequest(
  options: APIOptions<void> = {}
) {
  const props: UseAPILazyProps<void> = {
    url: "review/rating/v1/municipalities/batch",
    kind: "post",
    options,
    header: {
      Authorization: `Basic ${BASIC_AUTH}`,
    },
    hostOverride,
  };
  const api = useApiLazy<void>(props);
  const call = async (body: NewMunicipalityRequest[]) =>
    await api.call({
      ...props,
      body,
    });
  return { ...api, call };
}

// 🟧 PUT / - Update a new municipality request
export function useApiUpdateMunicipalityRequest(
  options: APIOptions<MunicipalityChangeRequest> = {}
) {
  const props: UseAPILazyProps<MunicipalityChangeRequest> = {
    url: "",
    kind: "put",
    options,
    header: {
      Authorization: `Basic ${BASIC_AUTH}`,
    },
    hostOverride,
  };
  const api = useApiLazy<MunicipalityChangeRequest>(props);
  const call = async (requestId: string, body: UpdateMunicipalityStatus) =>
    await api.call({
      ...props,
      url: `review/rating/v1/municipalities/${requestId}`,
      body,
    });
  return { ...api, call };
}
